import i18n from "../i18n";
import { MENU_LIST } from "./constants";

const labelKeyByName = {};
for (const menu of Object.values(MENU_LIST)) {
    labelKeyByName[menu.name] = labelKeyByName[menu.name] || menu.labelKey;
    (menu.subStates || []).forEach(sub => {
        labelKeyByName[sub.name] = labelKeyByName[sub.name] || sub.labelKey;
    });
}

// Pages set their title to the English menu name (a stable identifier); translate it at render time.
export const translatePageIdentifier = (value) =>
    typeof value === "string" && labelKeyByName[value] ? i18n.t(labelKeyByName[value]) : value;
